import store from '@/store'
import { EventBus } from '@didi/events'
import { i18n } from './i18n'
import { isObject } from './util'

/**
 * 通用错误处理中间件 处理errno!==0 的情况, 返回整个请求结果
 */
export async function errno (deferred) {
  try {
    const ret = await deferred
    if (ret) {
      const { errno } = ret
      if (errno !== 0) {
        EventBus.emit('ajaxErrorToast', ret.errmsg || ret)
        throw new Error(ret)
      } else {
        return ret
      }
    }
  } catch (err) {
    console.warn(err)
  }
}

/**
 * 通用错误处理中间件 处理errno!==0 的情况, 直接返回data
 */
export async function errnoData (deferred) {
  try {
    const ret = await deferred
    if (ret && isObject(ret)) {
      const { errno, data } = ret
      if (errno !== 0) {
        EventBus.emit('ajaxErrorToast', ret.errmsg || ret)
        throw new Error(ret)
      } else {
        return data
      }
    }
    return ret
  } catch (err) {
    console.warn(err)
  }
}

/**
 * 增加loading遮罩的中间件
 */
export async function preloading (deferred) {
  store.dispatch('showLoading')
  try {
    const ret = await deferred
    store.dispatch('hideLoading')
    return ret
  } catch (err) {
    store.dispatch('hideLoading')
    console.warn(err)
  }
}

/**
 * 增加网络异常中间件
 */
export async function networkError (deferred) {
  try {
    const ret = await deferred
    if (ret == null) {
      return { errno: -1, errmsg: i18n.gettext('未连接到服务器') }
    } else {
      return ret
    }
  } catch (err) {
    return { errno: -1, errmsg: i18n.gettext('未连接到服务器') }
  }
}
